const getDefaultUser = () => {
    let user1 = localStorage.getItem("user1");
    if (user1 && user1 !== "undefined") {
        return JSON.parse(user1);
    } else {
        return {};
    }
};

const authHeader = () => {
    const user1 = localStorage.getItem("user1") ? getDefaultUser() : {};
    const token = user1?.token || localStorage.getItem("token");
    if (token) {
        return { Authorization: `${token}` };
    } else {
        return {};
    }
};

export default authHeader;